import React, {FC, useEffect, useState} from "react"
import styled, {css} from "styled-components"

import {Deal, DealType} from "@irati/types"
import {isDealUnavailable} from "@irati/deals/helpers/deals/isDealUnavailable"
import {getColorFromThumbnail, getDealTileImage, getDealTileImageWithPadding} from "@irati/utils/images"
import GradientOverlay from "@irati/ui/src/GradientOverlay"

import dealDefaultCardImage from "../../images/dealDefaultCardImage.jpg"

interface CardImageWrapperProps {
  deal: Deal
}

const CardImage: FC<CardImageWrapperProps> = ({children, deal}) => {
  const [dealColor, setDealColor] = useState<string>()

  const isUnavailable = isDealUnavailable(deal)
  const isTypeMerchandise = deal.type === DealType.Merchandise
  const gradientType = isTypeMerchandise ? "linear" : "radial"

  useEffect(() => {
    if (!deal.cardImage && deal.thumbnailImage) {
      getColorFromThumbnail(deal.thumbnailImage).then((color) => {
        setDealColor(color)
      })
    }
  }, [])

  let dealCardImageSrc = !deal.cardImage && !deal.thumbnailImage && dealDefaultCardImage
  if (deal.cardImage) {
    const imgTransformation = isTypeMerchandise ? getDealTileImageWithPadding : getDealTileImage
    dealCardImageSrc = imgTransformation(deal.cardImage)
  }

  return (
    <ImgWrapper color={dealColor} isUnavailable={isUnavailable}>
      <Image imgUrl={dealCardImageSrc} text={deal.brandName} />
      <GradientOverlay gradientType={gradientType} />
      {children}
    </ImgWrapper>
  )
}

export default CardImage

const ImgWrapper = styled.div<{color?: string; isUnavailable?: boolean}>`
  overflow: hidden;
  position: relative;
  height: 132px;
  ${({color}) => color && `background-color: ${color};`}
  ${({isUnavailable}) => isUnavailable && "opacity: 60%;"}
`

const Image = styled.div<{imgUrl?: string; text?: string}>`
  ${({theme, imgUrl, text}) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${imgUrl &&
    css`
      background-image: url(${imgUrl});
      background-position: center;
      background-size: cover;
    `}

    ${!imgUrl &&
    text &&
    css`
      top: -50%;
      left: -50%;
      width: 170%;
      height: 120%;
      transform: rotate(-16deg);
      :before {
        content: "${`${text} `.repeat(300)}";
        color: ${theme.colors.greys.white};
        font-family: ${theme.font.medium};
        font-size: 12px;
        line-height: 20px;
        transform: rotate(-15deg) scale(1.5);
        opacity: 55%;
      }
    `}
  `};
`
